angular.module('services.delivery.SimulationService', [
  'global'
])

/**
 * The SimulationService service stores methods used to access
 * system APIs.
 *
 * @class SimulationService
 * @constructor
 * @module services.delivery.SimulationService
 */
.factory('SimulationService', [
  'ModelsService',
  function (ModelsService) {
    'use strict';

    var service = {

      simulation: [],

      progress: {
        current: null,
        disabled: []
      },

      /**
       * Returns simulation.  If a caseId is
       * provided will return a single case.  If no
       * caseId is provided will return all simulation.
       *
       * @param {string} [caseId] - param to return only a specific case
       * @return {Object|Array<Object>} All entries
       */
      get: function get(caseId) {
        var ret;

        service.simulation = ModelsService.read('cases');

        if (caseId) {
          ret = _.find(service.simulation, { id: caseId });
        } else {
          ret = service.simulation;
        }

        return ret;
      },

      /**
       * Sets the ID of the current state
       *
       * @param {string} stateId - State Identifier
       */
      setCurrentProgress: function setCurrentProgress(stateId) {
        service.progress.current = stateId;
      },

      /**
       * Adds a stateId to the list of disabled items
       * A state is disabled once it has been attempted.
       *
       * @param {string} stateId - State Identifier
       * @return {Array<string>} Array of disabled stateIds
       */
      addToDisabled: function addToDisabled(stateId) {
        service.progress.disabled.push(stateId);

        return service.progress.disabled;
      },

      /**
       * Checks the provided stateId to determine if that
       * state is disabled;
       *
       * @param {string} stateId - State Identifier
       * @return {boolean} Disabled status
       */
      checkForDisabled: function checkForDisabled(stateId) {
        return _.includes(service.progress.disabled, stateId);
      }

    };

    return service;
  }
]);
